<template>
  <v-tooltip bottom v-if="bookingHasVias == true">
    <template v-slot:activator="{ on }">
      <div
        v-bind:style="{width: large ? '72px' : '24px'}"
        style="background-color: #dadada; border-radius: 8px; padding-top: 2px;"
        v-on="on"
      >
        <center>
          <span>{{ numberOfVias }}{{large ? ' Vias' : ''}}&nbsp;</span>
        </center>
      </div>
    </template>
    <div v-html="viasForBooking()"></div>
  </v-tooltip>
</template>

<script>
import { Overwatch } from "@/components/util/Overwatch.js";

export default {
  name: "viasforbooking",
  props: {
    booking: Object,
    large: { type: Boolean, default: false },
  },
  computed: {
    bookingHasVias: function () {
      return this.booking.destinations.length > 1;
    },
    numberOfVias() {
      return this.booking.destinations.length - 1;
    },
  },
  data() {
    return {
      on: false,
    };
  },
  methods: {
    viasForBooking() {
      return Overwatch.viasForBooking(this.booking);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
